import { WarnParameter } from '../enums/warn-parameter.enum';

export const isParameterAllowed = (
  parameter: string,
  allowedParameters
): boolean => {
  return allowedParameters.indexOf(parameter) >= 0;
};

export const getWarnLevel = (
  warnParameter: WarnParameter | string,
  thresholdsToEdit
): number => {
  const p = warnParameter as WarnParameter;
  const arrayIndex = (thresholdsToEdit ?? []).findIndex(t => t.parameter === p);
  return arrayIndex >= 0 ? thresholdsToEdit[arrayIndex].level : 1;
};
